import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Alert, Box, CircularProgress } from '@mui/material';
import { usePermissions } from '../contexts/PermissionsContext';
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/authSlice";
import { isTokenExpired } from "../redux/tokenUtils";

const ProtectedRoute = ({ children }) => {
  const { pathname } = useLocation();
  const { loading, error, canVisit } = usePermissions();
  const dispatch = useDispatch();
  const { accessToken, isAuthenticated, tenantType } = useSelector((state) => state.auth);
  const tokenFromStorage = localStorage.getItem('accessToken');
  const tokenMissing = !accessToken || !tokenFromStorage;
  const tokenExpired = isTokenExpired(accessToken);

  useEffect(() => {
    if (tokenMissing || tokenExpired) {
      dispatch(logout());
    }
  }, [tokenMissing, tokenExpired, dispatch]);

  if (!isAuthenticated || tokenMissing || tokenExpired) {
    return <Navigate to="/login" replace />;
  }

  // The system administration page uses its separate main-database authentication.
  if (pathname !== '/admin_page') {
    if (loading) return <Box sx={{ p: 3 }}><CircularProgress aria-label="Verifica permessi" /></Box>;
    if (error || !canVisit(pathname)) {
      if (
        !error
        && pathname === '/punto_cassa'
        && String(tenantType || '').toUpperCase() === 'RISTORANTE'
        && canVisit('/mappa_tavoli')
      ) {
        return <Navigate to="/mappa_tavoli" replace />;
      }
      return <Box sx={{ p: 3 }}><Alert severity="warning">{error || 'Non hai i permessi per accedere a questa sezione. Contatta un amministratore.'}</Alert></Box>;
    }
  }
  return children;
};


export default ProtectedRoute;
